module.exports = __webpack_public_path__ + "static/media/physical_rsvp.807c0e84.svg";